import { resultObj } from "components/atoms/chart/logic/chartProvider"
// import { EXCHANGE } from "config/const"

export const indexDataList: Array<object> = [
  {
    Symbol: "101",
    SecurityType: 0,
    Exchange: 1,
    ExchangeName: "東証",
    SymbolName: "日経平均",
    SymbolNameS: "日経平均",
    NumberOfDecimals: 2,
    DisplayCountryName: "日本",
  },
  {
    Symbol: "151",
    SecurityType: 0,
    Exchange: 1,
    ExchangeName: "東証",
    TradeDayTo: 0,
    SymbolName: "TOPIX",
    SymbolNameS: "TOPIX",
    NumberOfDecimals: 2,
  },
  {
    Symbol: "105",
    SecurityType: 0,
    Exchange: 1,
    ExchangeName: "東証",
    TradeDayTo: 0,
    SymbolName: "JPX日経400",
    SymbolNameS: "JPX日経400",
    NumberOfDecimals: 2,
  },
  {
    Symbol: "154",
    SecurityType: 0,
    Exchange: 1,
    ExchangeName: "東証",
    TradeDayTo: 0,
    SymbolName: "東証マザーズ",
    SymbolNameS: "東証マザーズ",
    NumberOfDecimals: 2,
  },
  {
    Symbol: "190",
    SecurityType: 0,
    Exchange: 1,
    ExchangeName: "東証",
    TradeDayTo: 0,
    SymbolName: "JASDAQ指数",
    SymbolNameS: "JASDAQ指数",
    NumberOfDecimals: 2,
  },
  {
    Symbol: "155",
    SecurityType: 0,
    Exchange: 1,
    ExchangeName: "東証",
    TradeDayTo: 0,
    SymbolName: "REIT総合",
    SymbolNameS: "REIT総合",
    NumberOfDecimals: 2,
  },
  {
    Symbol: "HSI",
    SecurityType: 0,
    Exchange: 3010,
    ExchangeName: null,
    TradeDayTo: 0,
    SymbolName: "ハンセン",
    SymbolNameS: "ハンセン",
    NumberOfDecimals: 2,
    DisplayCountryName: "香港",
  },
  {
    Symbol: "SSEC",
    SecurityType: 0,
    Exchange: 3020,
    ExchangeName: null,
    TradeDayTo: 0,
    SymbolName: "上海総合",
    SymbolNameS: "上海総合",
    NumberOfDecimals: 2,
    DisplayCountryName: "中国",
  },
  {
    Symbol: "SZSC",
    SecurityType: 0,
    Exchange: 2020,
    ExchangeName: null,
    TradeDayTo: 0,
    SymbolName: "深セン総合",
    SymbolNameS: "深セン総合",
    NumberOfDecimals: 2,
  },
  {
    Symbol: "KS11",
    SecurityType: 0,
    Exchange: 2040,
    ExchangeName: null,
    TradeDayTo: 0,
    SymbolName: "韓国総合",
    SymbolNameS: "韓国総合",
    NumberOfDecimals: 2,
    DisplayCountryName: "韓国",
  },
  {
    Symbol: "TWII",
    SecurityType: 0,
    Exchange: 2030,
    ExchangeName: null,
    TradeDayTo: 0,
    SymbolName: "台湾加権",
    SymbolNameS: "台湾加権",
    NumberOfDecimals: 2,
    DisplayCountryName: "台湾",
  },
  {
    Symbol: "STI",
    SecurityType: 0,
    Exchange: 2050,
    ExchangeName: null,
    TradeDayTo: 0,
    SymbolName: "シンガポール ST指数",
    SymbolNameS: "シンガポール ST指数",
    NumberOfDecimals: 2,
    DisplayCountryName: "シンガポール",
  },
  {
    Symbol: "SETI",
    SecurityType: 0,
    Exchange: 2060,
    ExchangeName: null,
    TradeDayTo: 0,
    SymbolName: "タイSET指数",
    SymbolNameS: "タイSET指数",
    NumberOfDecimals: 2,
    DisplayCountryName: "タイ",
  },
  {
    Symbol: "KLSE",
    SecurityType: 0,
    Exchange: 2070,
    ExchangeName: null,
    TradeDayTo: 0,
    SymbolName: "クアラルンプール総合",
    SymbolNameS: "クアラルンプール総合",
    NumberOfDecimals: 2,
    DisplayCountryName: "マレーシア",
  },
  {
    Symbol: "JKSE",
    SecurityType: 0,
    Exchange: 2080,
    ExchangeName: null,
    TradeDayTo: 0,
    SymbolName: "ジャカルタ総合",
    SymbolNameS: "ジャカルタ総合",
    NumberOfDecimals: 2,
    DisplayCountryName: "インドネシア",
  },
  {
    Symbol: "PSI",
    SecurityType: 0,
    Exchange: 2090,
    ExchangeName: null,
    TradeDayTo: 0,
    SymbolName: "フィリピン総合",
    SymbolNameS: "フィリピン総合",
    NumberOfDecimals: 2,
    DisplayCountryName: "フィリピン",
  },
  {
    Symbol: "VNI",
    SecurityType: 0,
    Exchange: 2100,
    ExchangeName: null,
    TradeDayTo: 0,
    SymbolName: "ベトナムVN",
    SymbolNameS: "ベトナムVN",
    NumberOfDecimals: 2,
    DisplayCountryName: "ベトナム",
  },
  {
    Symbol: "DJI",
    SecurityType: 0,
    Exchange: 100,
    ExchangeName: null,
    TradeDayTo: 0,
    SymbolName: "NYダウ",
    SymbolNameS: "NYダウ",
    NumberOfDecimals: 2,
    DisplayCountryName: "米国",
  },
  {
    Symbol: "INX",
    SecurityType: 0,
    Exchange: 100,
    ExchangeName: null,
    TradeDayTo: 0,
    SymbolName: "S&P500",
    SymbolNameS: "S&P500",
    NumberOfDecimals: 2,
  },
  {
    Symbol: "IXIC",
    SecurityType: 0,
    Exchange: 100,
    ExchangeName: null,
    TradeDayTo: 0,
    SymbolName: "NASDAQ",
    SymbolNameS: "NASDAQ",
    NumberOfDecimals: 2,
  },
  {
    Symbol: "TA35",
    SecurityType: 0,
    Exchange: 2110,
    ExchangeName: null,
    TradeDayTo: 0,
    SymbolName: "テルアビブ35種指数",
    SymbolNameS: "テルアビブ35種指数",
    NumberOfDecimals: 2,
    DisplayCountryName: "イスラエル",
  },
]

export const defaultData: resultObj = {
  Chart: {
    Columns: [],
    LegList: [],
  },
  IsDelay: false,
  MaxSeqNum: 0,
  Message: "",
  MinSeqNum: 0,
  Result: 0,
  StartTime: "",
  Symbol: {
    Ask: null,
    Bid: null,
    CalcLastClose: null,
    ChangedPrice: null,
    ChangedRatio: null,
    ComplianceFlag: null,
    Division: null,
    Enable2Way: null,
    Exchange: null,
    ExchangeDivisions: null,
    HighPrice: null,
    HighPriceTime: null,
    LastClose: null,
    LastCloseTime: null,
    LowPrice: null,
    LowPriceTime: null,
    MainExchange: null,
    NumberOfDecimals: null,
    OpenPrice: null,
    OpenPriceTime: null,
    Price: null,
    PriceCompare: null,
    PriceCompareText: null,
    PriceStatus: null,
    PriceTime: null,
    SecurityType: null,
    ShortSellingFlag: null,
    Symbol: null,
    SymbolCode: null,
    SymbolName: null,
    SymbolNameS: null,
    TemporaryPost: null,
    TradValue: null,
    TradVolume: null,
    VWAP: null,
    Ticker: "",
  },
}

export const requestParam = [
  //日経平均
  {
    Symbol: "101",
    Exchange: 1,
    SecurityType: 0,
  },
  //TOPIX
  {
    Symbol: "151",
    Exchange: 1,
    SecurityType: 0,
  },
  //JPX日経400
  {
    Symbol: "105",
    Exchange: 1,
    SecurityType: 0,
  },
  //東証マザーズ
  {
    Symbol: "154",
    Exchange: 1,
    SecurityType: 0,
  },
  //JASDAQ指数
  {
    Symbol: "190",
    Exchange: 1,
    SecurityType: 0,
  },
  //REIT総合
  {
    Symbol: "155",
    Exchange: 1,
    SecurityType: 0,
  },
  //ハンセン
  {
    Symbol: "HSI",
    Exchange: 3010,
    SecurityType: 0,
  },
  //上海総合
  {
    Symbol: "SSEC",
    Exchange: 3020,
    SecurityType: 0,
  },
  //深セン総合
  {
    Symbol: "SZSC",
    Exchange: 2020,
    SecurityType: 0,
  },
  //韓国総合
  {
    Symbol: "KS11",
    Exchange: 2040,
    SecurityType: 0,
  },
  //台湾加権
  {
    Symbol: "TWII",
    Exchange: 2030,
    SecurityType: 0,
  },
  //シンガポール ST指数
  {
    Symbol: "STI",
    Exchange: 2050,
    SecurityType: 0,
  },
  //タイSET指数
  {
    Symbol: "SETI",
    Exchange: 2060,
    SecurityType: 0,
  },
  //クアラルンプール総合
  {
    Symbol: "KLSE",
    Exchange: 2070,
    SecurityType: 0,
  },
  //ジャカルタ総合
  {
    Symbol: "JKSE",
    Exchange: 2080,
    SecurityType: 0,
  },
  //フィリピン総合
  {
    Symbol: "PSI",
    Exchange: 2090,
    SecurityType: 0,
  },
  //ベトナムVN
  {
    Symbol: "VNI",
    Exchange: 2100,
    SecurityType: 0,
  },
  //NYダウ
  {
    Symbol: "DJI",
    Exchange: 100,
    SecurityType: 0,
  },
  //P500
  {
    Symbol: "INX",
    Exchange: 100,
    SecurityType: 0,
  },
  //NASDAQ
  {
    Symbol: "IXIC",
    Exchange: 100,
    SecurityType: 0,
  },
  //テルアビブ35種指数
  {
    Symbol: "TA35",
    Exchange: 2110,
    SecurityType: 0,
  },
]

const EXCHANGE = {
  NONE: { id: 0, name: "東証" },
  TSE: { id: 1, name: "東証" },
  OSE: { id: 2, name: "大証" },
  NSE: { id: 3, name: "名証" },
  FSE: { id: 5, name: "福証" },
  SSE: { id: 6, name: "札証" },
  OSE_DERIV_DAY: { id: 23, name: "大証派生日中" },
  OSE_DERIV_EVENING: { id: 24, name: "大証派生夕場" },
  NYSE: { id: 100 },
  US_EQUITY: { id: 300 },
  FX: { id: 400, name: "為替" },
  SZSE: { id: 2020, name: "深セン" },
  TWII: { id: 2030, name: "台湾" },
  KSSE: { id: 2040, name: "韓国" },
  STI: { id: 2050, name: "シンガポール" },
  SETI: { id: 2060, name: "タイ" },
  KLSE: { id: 2070, name: "マレーシア" },
  JKSE: { id: 2080, name: "インドネシア" },
  PSI: { id: 2090, name: "フィリピン" },
  VNI: { id: 2100, name: "ベトナム" },
  ILSE: { id: 2110, name: "イスラエル" },
  HKSE: { id: 3010, name: "香港" },
  SSEC: { id: 3020, name: "上海" },
  GB: { id: 13000, name: "国債" },
  PIR: { id: 13101, name: "政策金利" }, //Policy Interest Rate
  XAU_XAG: { id: 14000 }, //金現物,銀現物
}

export const summaryList = [
  { Name: "日本", CountryClass: "japan", Exchange: [EXCHANGE.TSE.id] },
  { Name: "米国", CountryClass: "usa", Exchange: [EXCHANGE.NYSE.id] },
  {
    Name: "中国",
    CountryClass: "china",
    Exchange: [EXCHANGE.SSEC.id, EXCHANGE.SZSE.id],
  },
  { Name: "香港", CountryClass: "hongkong", Exchange: [EXCHANGE.HKSE.id] },
  { Name: "韓国", CountryClass: "korea", Exchange: [EXCHANGE.KSSE.id] },
  { Name: "台湾", CountryClass: "taiwan", Exchange: [EXCHANGE.TWII.id] },
  {
    Name: "フィリピン",
    CountryClass: "philippines",
    Exchange: [EXCHANGE.PSI.id],
  },
  {
    Name: "インドネシア",
    CountryClass: "indonesia",
    Exchange: [EXCHANGE.JKSE.id],
  },
  {
    Name: "シンガポール",
    CountryClass: "singapore",
    Exchange: [EXCHANGE.STI.id],
  },
  {
    Name: "マレーシア",
    CountryClass: "malaysia",
    Exchange: [EXCHANGE.KLSE.id],
  },
  { Name: "タイ", CountryClass: "thailand", Exchange: [EXCHANGE.SETI.id] },
  { Name: "ベトナム", CountryClass: "vietnam", Exchange: [EXCHANGE.VNI.id] },
  { Name: "イスラエル", CountryClass: "israel", Exchange: [EXCHANGE.ILSE.id] },
]

export const TERM_EXTERNAL = [
  {
    id: 0,
    displayTitle: "1日",
    key: "5m",
  },
  {
    id: 1,
    displayTitle: "1ヶ月",
    key: "1D",
  },
  {
    id: 2,
    displayTitle: "3ヶ月",
    key: "1D",
  },
  {
    id: 3,
    displayTitle: "6ヶ月",
    key: "1W",
  },
  {
    id: 4,
    displayTitle: "1年",
    key: "1W",
  },
  {
    id: 5,
    displayTitle: "3年",
    key: "1M",
  },
]

export const loginErrorResult = 2147483647
